<template :key="index">
  <div class="py-3">
    <BaseHelpTooltip
      popover-placement="bottom"
    >
      <template slot="left">
        <h5 class="card-text mb-5">
          Creative Fonts
        </h5>
      </template>
      <template slot="popover-body">
        <p class="small">
          Please choose a font from one of over 450 Google fonts. You may also
          change the font size and colour to customise your creative for
          maximum impact and compliance with your branding guidelines.
        </p>
      </template>
    </BaseHelpTooltip>
    <h6
      v-if="areEditableProperties('headline')"
    >
      Headline Font
    </h6>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('headlineFontFamily')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Family:</label>
        <div class="col-sm-7 input-group-sm">
          <BaseFontSelect
            id="headlineFontFamily"
            size="sm"
            v-model="creativeSettings.headlineFontFamily"
            @change="onSubmit('headlineFontFamily')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('headlineFontSize')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Size:</label>
        <div
          class="col-sm-7 input-group-sm"
        >
          <b-form-select
            v-model="creativeSettings.headlineFontSize"
            :options="sizeOptionsHeadline"
            data-test="creative-headline-size-options"
            @change="onSubmit('headlineFontSize')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('headlineFontColour')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Colour:</label>
        <div class="col-auto ml-auto input-group-sm">
          <BaseColourSelect
            v-model="creativeSettings.headlineFontColour"
            @change="onSubmit('headlineFontColour')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div v-if="areEditableProperties('body')">
      <hr class="my-3">
      <h6>
        Body Font
      </h6>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('bodyFontFamily')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Family:</label>
        <div class="col-sm-7 input-group-sm">
          <BaseFontSelect
            id="headlineFontFamily"
            size="sm"
            v-model="creativeSettings.bodyFontFamily"
            @change="onSubmit('bodyFontFamily')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('bodyFontSize')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Size:</label>
        <div class="col-sm-7 input-group-sm">
          <b-form-select
            v-model="creativeSettings.bodyFontSize"
            :options="sizeOptionsCopy"
            data-test="creative-headline-size-options"
            @change="onSubmit('bodyFontSize')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('bodyFontColour')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Colour:</label>
        <div class="col-auto ml-auto input-group-sm">
          <BaseColourSelect
            v-model="creativeSettings.bodyFontColour"
            @change="onSubmit('bodyFontColour')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div v-if="areEditableProperties('cta')">
      <hr class="my-3">
      <h6>
        Call to action Font
      </h6>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('ctaFontFamily')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Family:</label>
        <div class="col-sm-7 input-group-sm">
          <BaseFontSelect
            id="headlineFontFamily"
            size="sm"
            v-model="creativeSettings.ctaFontFamily"
            @change="onSubmit('ctaFontFamily')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('ctaFontSize')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Size:</label>
        <div class="col-sm-7 input-group-sm">
          <b-form-select
            v-model="creativeSettings.ctaFontSize"
            :options="sizeOptionsCta"
            data-test="creative-headline-size-options"
            @change="onSubmit('ctaFontSize')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('ctaBackgroundColour')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Background Colour:</label>
        <div class="col-auto ml-auto input-group-sm">
          <BaseColourSelect
            v-model="creativeSettings.ctaBackgroundColour"
            @change="onSubmit('ctaBackgroundColour')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="form-group input-group-sm"
      v-if="isEditableProperty('ctaFontColour')"
    >
      <div class="row align-items-center">
        <label class="col-sm-5 form-label">Colour:</label>
        <div class="col-auto ml-auto input-group-sm">
          <BaseColourSelect
            v-model="creativeSettings.ctaFontColour"
            @change="onSubmit('ctaFontColour')"
            :disabled="isReadOnly('creative-properties')"
          />
        </div>
      </div>
    </div>
    <div
      class="alert alert-warning"
      role="alert"
      v-if="areEditableProperties('headline')
        || areEditableProperties('body') || areEditableProperties('cta')"
    >
      <b-form-checkbox
        id="confirm-check"
        v-model="confirmCheck"
        name="confirm-check"
        :disabled="isCampaignReadonly"
      >
        <small>Don't show confirmation message again.</small>
      </b-form-checkbox>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'CreativeFonts',
  components: {
  },
  data() {
    return {
      index: 0,
      firstLoad: true,
      sizeOptionsHeadline: [
        { value: '20', text: '20px' },
        { value: '22', text: '22px' },
        { value: '24', text: '24px' },
        { value: '26', text: '26px' },
        { value: '28', text: '28px' },
        { value: '30', text: '30px' },
      ],
      sizeOptionsCopy: [
        { value: '14', text: '14px' },
        { value: '16', text: '16px' },
        { value: '18', text: '18px' },
        { value: '20', text: '20px' },
      ],
      sizeOptionsCta: [
        { value: '12', text: '12px' },
        { value: '14', text: '14px' },
        { value: '16', text: '16px' },
        { value: '18', text: '18px' },
        { value: '20', text: '20px' },
      ],
      confirmCheck: false,
      unsavedSettings: {},
    };
  },
  props: {
    creativeSettings: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Array,
      default: () => [],
    },
    editableProperties: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('campaigns', {
      isCampaignReadonly: campaignTypes.GET_IS_CAMPAIGN_READONLY,
    }),
  },
  methods: {
    onSubmit() {
      if (!this.confirmCheck) {
        this.$bvModal.msgBoxConfirm('This change will update the creative for this campaign and be applied to all content items.', {
          title: 'Are you sure?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,

        })
          .then((value) => {
            if (value) this.onUpdateSettings();
            else {
              this.$emit('set');
            }
          });
      } else {
        this.onUpdateSettings();
      }
    },
    onUpdateSettings() {
      const payload = {
        ...this.creativeSettings,
      };
      this.$emit('submit', payload);
    },
    isReadOnly(property) {
      return this.isCampaignReadonly || this.readOnly.includes(property);
    },
    isEditableProperty(property) {
      return this.editableProperties.includes(property);
    },
    areEditableProperties(type) {
      const regex = new RegExp(`${type}Font`, 'g');
      return this.editableProperties.some((property) => regex.test(property));
    },
  },
  mounted() {
    if (localStorage.getItem('confirmCheck')) this.confirmCheck = JSON.parse(localStorage.getItem('confirmCheck'));
  },
  watch: {
    confirmCheck: {
      handler() {
        localStorage.setItem('confirmCheck', JSON.stringify(this.confirmCheck));
      },
    },
  },
};
</script>
